// client/src/components/NewCustomerDiscount.jsx
// Promotional card for new customers showing first-order discount

import React, { useContext } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';
import { FaGift, FaArrowRight } from 'react-icons/fa';
import './NewCustomerDiscount.css';

const NewCustomerDiscount = () => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  // Hide if user is logged in (they're not a new customer)
  if (user) {
    return null;
  }

  const handleShopNow = () => {
    navigate('/products');
  };

  const handleRegister = () => {
    navigate('/register');
  };

  return (
    <div className="new-customer-discount-container">
      <Card className="new-customer-discount-card">
        <Card.Body>
          <div className="discount-content">
            <div className="discount-icon">
              <FaGift />
            </div>
            <div className="discount-text">
              <h5>🎉 New Customer Offer</h5>
              <p className="discount-amount">Get 5% Off Your First Order</p>
              <p className="discount-code">
                Use code: <strong>WELCOME5</strong>
              </p>
              <p className="discount-description">
                Sign up and get an exclusive 5% discount on your first purchase. No minimum spend required!
              </p>
            </div>
          </div>
          <div className="discount-actions">
            <Button
              variant="primary"
              className="discount-btn"
              onClick={handleRegister}
            >
              Register Now
              <FaArrowRight className="ms-2" />
            </Button>
            <Button
              variant="outline-secondary"
              className="discount-btn-secondary"
              onClick={handleShopNow}
            >
              Browse Products
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default NewCustomerDiscount;
